import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/inter/latin-800.css';
import './i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { App } from './App';
import { CartProvider } from './context/CartContext';
import { GlobalStyles } from './styles/GlobalStyles';
import { theme } from './styles/theme';
const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element not found');
}
createRoot(rootElement).render(_jsx(StrictMode, { children: _jsxs(ThemeProvider, { theme: theme, children: [_jsx(GlobalStyles, {}), _jsx(BrowserRouter, { children: _jsx(CartProvider, { children: _jsx(App, {}) }) })] }) }));
